import { GenericAbortSignal } from 'axios';

import { TFormFile } from '@/utils/formFileList';

import companyLogo from '@/assets/loanbud-logo.svg';

import APIinstance from '../config';

import { CloudFileDto } from '@/generated-types';

export const uploadFormFiles = async (
	files: TFormFile[],
	signal?: GenericAbortSignal,
): Promise<CloudFileDto[]> => {
	const formData = new FormData();

	files.forEach((file) => {
		if (file.originFileObj) {
			formData.append('files', file.originFileObj);
		}
	});

	const data = await uploadFiles(formData, signal);

	return data;
};

export const uploadFiles = async (
	formData: FormData,
	signal?: GenericAbortSignal,
): Promise<CloudFileDto[]> => {
	const { data } = await APIinstance.post<CloudFileDto[]>('cloud-files', formData, {
		headers: {
			'content-type': 'multipart/form-data',
		},
		signal,
	});

	return data;
};

export const deleteFile = async (fileId: string): Promise<void> => {
	await APIinstance.delete(`cloud-files/${fileId}`);
};

export const getPublicFileUrl = (fileId?: string): string => {
	if (!fileId) {
		return '';
	}

	return `${process.env.API_BASE_URL}/api/v1/public-cloud-files/${fileId}`;
};

export const getPublicFileLogo = (logoId?: string): string => {
	if (!logoId) {
		return companyLogo;
	}

	return `${process.env.API_BASE_URL}/api/v1/public-cloud-files/${logoId}`;
};

export const fetchFinalFileUrl = async (redirectUrl: string): Promise<string> => {
	const { url } = await fetch(redirectUrl);
	return url;
};
